// =============================================
// File: src/hooks/useSpirometryFlowDataset.js
// Purpose: Build smoothed breath-trace dataset + xMax for the chart
// =============================================
import { useMemo } from "react";
import { smoothSeriesBySeconds } from "../utils/results/smoothing";

export function useSpirometryFlowDataset({ data, t }) {
  const flowDataset = useMemo(() => {
    const xs = Array.isArray(data?.times) ? data.times : null;
    const raw = Array.isArray(data?.best_traces?.[0])
      ? data.best_traces[0]
      : Array.isArray(data?.trace)
      ? data.trace
      : null;
    if (!xs || !raw || xs.length === 0 || raw.length === 0) return null;

    const n = Math.min(xs.length, raw.length);
    const SMOOTH_SEC = 1;
    const smoothed = smoothSeriesBySeconds(
      xs.slice(0, n),
      raw.slice(0, n),
      SMOOTH_SEC
    );

    return {
      label: t("activity.spirometry.flowLabel", {
        defaultValue: "Breath Trace",
      }),
      data: smoothed,
      tension: 0.35,
      borderWidth: 3,
      unit: t("activity.spirometry.flowUnit", { defaultValue: "L/s" }),
    };
  }, [data, t]);

  const xMax = useMemo(() => {
    if (!flowDataset?.data?.length) return 60;
    const lastX = flowDataset.data[flowDataset.data.length - 1].x ?? 0;
    return Math.max(15, Math.ceil(lastX));
  }, [flowDataset]);

  return { flowDataset, xMax };
}
